export const genderGroups = [
  { 
    id: "women", 
    name: { nl: "Dames", en: "Women", tr: "Kadınlar" },
    fullName: { nl: "Dames Behandelingen", en: "Women's Services", tr: "Kadın Hizmetleri" },
    badge: "👩 DAMES / KADIN",
    icon: "Sparkles",
    accent: "from-rose-500 to-pink-600"
  },
  { 
    id: "men", 
    name: { nl: "Heren", en: "Men", tr: "Erkekler" },
    fullName: { nl: "Heren Behandelingen", en: "Men's Services", tr: "Erkek Hizmetleri" },
    badge: "👨 HEREN / ERKEK",
    icon: "Scissors",
    accent: "from-slate-800 to-slate-900"
  }
];

export const serviceCategories = [
  // 👩 KADIN KATEGORİLERİ (WOMEN)
  { 
    id: "women_cut", 
    gender: "women",
    name: { nl: "Dames Knippen", en: "Women's Haircut", tr: "Kadın Saç Kesimi" },
    color: "bg-rose-700",
    badgeColor: "bg-rose-50 border-rose-200 text-rose-800"
  },
  { 
    id: "hair_coloring", 
    gender: "women",
    name: { nl: "Haarkleuring", en: "Hair Coloring", tr: "Saç Boyama" },
    color: "bg-amber-700",
    badgeColor: "bg-amber-50 border-amber-200 text-amber-800"
  },
  { 
    id: "highlight_lowlight", 
    gender: "women",
    name: { nl: "Highlights & Lowlights", en: "Highlights & Lowlights", tr: "Highlight ve Lowlight" },
    color: "bg-yellow-600",
    badgeColor: "bg-yellow-50 border-yellow-200 text-yellow-900"
  },
  { 
    id: "keratin_perm", 
    gender: "women",
    name: { nl: "Keratine & Botox", en: "Keratin & Hair Botox", tr: "Keratin ve Kalıcı Fön" },
    color: "bg-emerald-700",
    badgeColor: "bg-emerald-50 border-emerald-200 text-emerald-800"
  },
  { 
    id: "bridal_updo", 
    gender: "women",
    name: { nl: "Bruidskapsel & Opsteken", en: "Bridal & Updo", tr: "Gelin Saçı ve Topuz" },
    color: "bg-purple-700",
    badgeColor: "bg-purple-50 border-purple-200 text-purple-800"
  },
  { 
    id: "hair_styling", 
    gender: "women",
    name: { nl: "Föhnen & Styling", en: "Blow-dry & Styling", tr: "Fön & Şekillendirme" },
    color: "bg-indigo-700",
    badgeColor: "bg-indigo-50 border-indigo-200 text-indigo-800"
  },
  { 
    id: "women_perm", 
    gender: "women",
    name: { nl: "Permanent", en: "Perm", tr: "Perma" },
    color: "bg-teal-700",
    badgeColor: "bg-teal-50 border-teal-200 text-teal-800"
  },
  { 
    id: "brows_face_wax", 
    gender: "women",
    name: { nl: "Wenkbrauwen, Gezicht & Wax", en: "Brows, Face & Waxing", tr: "Kaş, Yüz ve Ağda" },
    color: "bg-pink-700",
    badgeColor: "bg-pink-50 border-pink-200 text-pink-800"
  },

  // 👨 ERKEK KATEGORİLERİ (MEN)
  { 
    id: "men_hair_beard", 
    gender: "men",
    name: { nl: "Heren Haar & Baard", en: "Men's Hair & Beard", tr: "Erkek Saç ve Sakal" },
    color: "bg-slate-800",
    badgeColor: "bg-slate-100 border-slate-300 text-slate-800"
  },
  { 
    id: "men_care_wax", 
    gender: "men",
    name: { nl: "Heren Verzorging & Wax", en: "Men's Grooming & Wax", tr: "Erkek Bakım & Ağda" },
    color: "bg-teal-700",
    badgeColor: "bg-teal-50 border-teal-200 text-teal-800"
  },
  { 
    id: "mens_hairpiece", 
    gender: "men",
    name: { nl: "Haarwerk Heren", en: "Men's Hair Systems", tr: "Erkek Peruk" },
    color: "bg-slate-950",
    badgeColor: "bg-amber-50 border-amber-300 text-slate-900"
  }
];

export const services = [
  // =========================================================
  // 👩 1. KADIN HİZMETLERİ (WOMEN'S SERVICES)
  // =========================================================

  // ✂️ Kadın Saç Kesimi
  {
    id: "w-wash-cut-dry",
    gender: "women",
    name: { nl: "Wassen, knippen en drogen", en: "Wash, haircut and dry", tr: "Yıkama, kesim ve kurutma" },
    category: "women_cut",
    categoryName: { nl: "Dames Knippen", en: "Women's Haircut", tr: "Kadın Saç Kesimi" },
    price: 35.0,
    duration: 45,
    popular: true,
    description: {
      nl: "Professioneel wassen, vakkundige knipbeurt op maat en drogen.",
      en: "Professional hair wash, tailored haircut to suit your facial structure, and natural drying.",
      tr: "Profesyonel saç yıkama, yüz hatlarınıza uygun özenli kesim ve kurutma."
    }
  },
  {
    id: "w-curly-wash-cut",
    gender: "women",
    name: { nl: "Krullend haar wassen en knippen", en: "Curly hair wash and cut", tr: "Kıvırcık saç yıkama ve kesim" },
    category: "women_cut",
    categoryName: { nl: "Dames Knippen", en: "Women's Haircut", tr: "Kadın Saç Kesimi" },
    price: 40.0,
    duration: 50,
    popular: true,
    description: {
      nl: "Speciale knip- en wastechniek voor krullend haar om natuurlijke veerkracht en definitie te maximaliseren.",
      en: "Specialized cutting and washing technique tailored to enhance natural curls and wavy texture.",
      tr: "Kıvırcık ve dalgalı saçlara özel bukle belirginleştirici ve hacim kazandırıcı kesim ve yıkama."
    }
  },
  {
    id: "w-bangs-cut",
    gender: "women",
    name: { nl: "Pony knippen", en: "Bangs / Fringe trim", tr: "Kâkül kesimi" },
    category: "women_cut",
    categoryName: { nl: "Dames Knippen", en: "Women's Haircut", tr: "Kadın Saç Kesimi" },
    price: 10.0,
    duration: 15,
    description: {
      nl: "Snelle en nauwkeurige pony knipbeurt voor een frisse oogopslag.",
      en: "Quick precision bangs trim to accentuate your eyes and face framing.",
      tr: "Hızlı ve hassas kâkül düzeltme ve yüz çevresi şekillendirme."
    }
  },
  {
    id: "w-girls-under-6",
    gender: "women",
    name: { nl: "Meisjes knippen (tot 6 jaar)", en: "Girls haircut (under 6 yrs)", tr: "6 yaşına kadar kız çocuk kesimi" },
    category: "women_cut",
    categoryName: { nl: "Dames Knippen", en: "Women's Haircut", tr: "Kadın Saç Kesimi" },
    price: 25.0,
    duration: 30,
    description: {
      nl: "Geduldige, vriendelijke en comfortabele knipbeurt voor kleine meisjes tot 6 jaar.",
      en: "Gentle, patient and fun haircut experience for little girls up to 6 years.",
      tr: "Küçük prenseslere özel sabırlı, neşeli saç kesimi ve hafif kurutma."
    }
  },

  // 🎨 Saç Boyama
  {
    id: "color-root-ammonia-free",
    gender: "women",
    name: { nl: "Ammoniakvrije uitgroei kleuring", en: "Ammonia-free root touch-up", tr: "Amonyaksız dip boya" },
    category: "hair_coloring",
    categoryName: { nl: "Haarkleuring", en: "Hair Coloring", tr: "Saç Boyama" },
    price: 65.0,
    duration: 60,
    isStartingPrice: true,
    description: {
      nl: "Zachte, ammoniakvrije formule voor een natuurlijke en gezonde uitgroei kleuring. (Vanaf prijs)",
      en: "Gentle ammonia-free organic formula for healthy root touch-up without scalp irritation. (Starting price)",
      tr: "Saç derisine ve saç teline zarar vermeyen amonyaksız doğal organik dip boyama. (Başlangıç fiyatı)"
    }
  },
  {
    id: "color-root-regular",
    gender: "women",
    name: { nl: "Normale uitgroei kleuring", en: "Regular root touch-up", tr: "Normal dip boya" },
    category: "hair_coloring",
    categoryName: { nl: "Haarkleuring", en: "Hair Coloring", tr: "Saç Boyama" },
    price: 55.0,
    duration: 60,
    isStartingPrice: true,
    description: {
      nl: "Klassieke dekkende uitgroeibehandeling met salonkwaliteit pigmenten. (Vanaf prijs)",
      en: "Classic full-coverage salon-grade root coloring treatment. (Starting price)",
      tr: "Klasik tam beyaz kapatıcı profesyonel dip boya uygulaması. (Başlangıç fiyatı)"
    }
  },
  {
    id: "color-full-hair",
    gender: "women",
    name: { nl: "Volledige haarkleuring", en: "Full hair coloring", tr: "Bütün saç boyama" },
    category: "hair_coloring",
    categoryName: { nl: "Haarkleuring", en: "Hair Coloring", tr: "Saç Boyama" },
    price: 85.0,
    duration: 90,
    isStartingPrice: true,
    popular: true,
    description: {
      nl: "Volledige kleuring van aanzet tot punt met rijke pigmenten en verzorgende glansformule. (Vanaf prijs)",
      en: "Complete root-to-tip coloring with rich salon pigments and conditioning shine gloss. (Starting price)",
      tr: "Dipten uca homojen, kalıcı ve saç tellerine parlaklık kazandıran tam saç boyama. (Başlangıç fiyatı)"
    }
  },

  // ✨ Highlight ve Lowlight
  {
    id: "hl-highlight-lowlight",
    gender: "women",
    name: { nl: "Highlight & Lowlight", en: "Highlight & Lowlight", tr: "Highlight & Lowlight" },
    category: "highlight_lowlight",
    categoryName: { nl: "Highlights & Lowlights", en: "Highlights & Lowlights", tr: "Highlight ve Lowlight" },
    price: 160.0,
    duration: 120,
    isStartingPrice: true,
    popular: true,
    description: {
      nl: "Professionele highlights of lowlights voor schitterende diepte, contrast en multidimensionale glans. (Vanaf prijs)",
      en: "Professional highlights or lowlights creating luminous contrast, dimension and shine. (Starting price)",
      tr: "Saça ışıltı, derinlik ve kontrast kazandıran profesyonel röfle & gölge renklendirme. (Başlangıç fiyatı)"
    }
  },

  // 💆‍♀️ Keratine & Botox
  {
    id: "care-botox",
    gender: "women",
    name: { nl: "Haar botox behandeling", en: "Hair botox treatment", tr: "Saç botoksu" },
    category: "keratin_perm",
    categoryName: { nl: "Keratine & Botox", en: "Keratin & Hair Botox", tr: "Keratin ve Kalıcı Fön" },
    price: 110.0,
    duration: 90,
    isStartingPrice: true,
    description: {
      nl: "Diep herstellende kuur met hyaluronzuur en vitaminen voor zijdezacht haar. (Vanaf prijs)",
      en: "Intensive deep rejuvenation with hyaluronic acid and vitamin botox for silky softness. (Starting price)",
      tr: "Yıpranmış telleri onaran yoğun nem, hyaluronik asit ve vitamin botoks yüklemesi. (Başlangıç fiyatı)"
    }
  },
  {
    id: "care-protein",
    gender: "women",
    name: { nl: "Proteïne behandeling", en: "Protein repair treatment", tr: "Protein bakımı" },
    category: "keratin_perm",
    categoryName: { nl: "Keratine & Botox", en: "Keratin & Hair Botox", tr: "Keratin ve Kalıcı Fön" },
    price: 110.0,
    duration: 90,
    isStartingPrice: true,
    description: {
      nl: "Intensieve versterking van de haarvezel voor broos en verzwakt haar. (Vanaf prijs)",
      en: "Deep structural protein infusion to rebuild fragile and damaged hair bonds. (Starting price)",
      tr: "Zayıf ve kırılgan saç yapısını güçlendiren yoğun protein kompleksi. (Başlangıç fiyatı)"
    }
  },
  {
    id: "care-keratin",
    gender: "women",
    name: { nl: "Keratine behandeling", en: "Keratin smoothing treatment", tr: "Keratin bakımı" },
    category: "keratin_perm",
    categoryName: { nl: "Keratine & Botox", en: "Keratin & Hair Botox", tr: "Keratin ve Kalıcı Fön" },
    price: 110.0,
    duration: 105,
    isStartingPrice: true,
    popular: true,
    description: {
      nl: "Langdurige anti-pluis gladmaking, permanent steil effect en intense spiegelglans. (Vanaf prijs)",
      en: "Long-lasting anti-frizz smoothing, permanent blow-dry effect and mirror shine. (Starting price)",
      tr: "Elektriklenmeyi ve kabarmayı önleyen, aylarca pürüzsüz kalıcı fön etkisi ve parlaklık. (Başlangıç fiyatı)"
    }
  },

  // 👰 Gelin Saçı ve Topuz
  {
    id: "style-bridal",
    gender: "women",
    name: { nl: "Bruidskapsel", en: "Bridal hair styling", tr: "Gelin saçı" },
    category: "bridal_updo",
    categoryName: { nl: "Bruidskapsel & Opsteken", en: "Bridal & Updo", tr: "Gelin Saçı ve Topuz" },
    price: 250.0,
    duration: 120,
    popular: true,
    description: {
      nl: "Exclusief bruidskapsel op maat inclusief sluier- en accessoirebevestiging voor uw droomdag.",
      en: "Bespoke luxury bridal hair styling including veil, tiara & accessory placement.",
      tr: "En özel gününüz için duvak/aksesuar montajlı kişiye özel lüks gelin başı tasarımı."
    }
  },
  {
    id: "style-updo",
    gender: "women",
    name: { nl: "Topuz / Opsteken", en: "Hair updo styling", tr: "Topuz" },
    category: "bridal_updo",
    categoryName: { nl: "Bruidskapsel & Opsteken", en: "Bridal & Updo", tr: "Gelin Saçı ve Topuz" },
    price: 80.0,
    duration: 60,
    isStartingPrice: true,
    popular: true,
    description: {
      nl: "Elegante opsteekkapsels voor bruiloften, gala's en speciale gelegenheden. (Vanaf prijs)",
      en: "Sophisticated modern and classic updo styles for galas, parties, and weddings. (Starting price)",
      tr: "Düğün, nişan ve özel davetler için şık modern veya klasik topuz modelleri. (Başlangıç fiyatı)"
    }
  },
  {
    id: "style-special-occasion",
    gender: "women",
    name: { nl: "Feestkapsel & Gelegenheidskapsel", en: "Special Occasion & Party Styling", tr: "Özel gün, mezuniyet & nişan saçı" },
    category: "bridal_updo",
    categoryName: { nl: "Bruidskapsel & Opsteken", en: "Bridal & Updo", tr: "Gelin Saçı ve Topuz" },
    price: 65.0,
    duration: 60,
    isStartingPrice: true,
    description: {
      nl: "Prachtige feestelijke kapsels voor gala's, verlovingen, diploma-uitreikingen en speciale gelegenheden. (Vanaf prijs)",
      en: "Glamorous party hair styling for proms, galas, engagements and celebrations. (Starting price)",
      tr: "Nişan, kına, mezuniyet ve özel davetler için göz alıcı şekillendirme ve dalgalar. (Başlangıç fiyatı)"
    }
  },

  // 💁‍♀️ Saç Şekillendirme
  {
    id: "style-blowdry",
    gender: "women",
    name: { nl: "Föhnen", en: "Blow-dry styling", tr: "Fön" },
    category: "hair_styling",
    categoryName: { nl: "Föhnen & Styling", en: "Blow-dry & Styling", tr: "Fön & Şekillendirme" },
    price: 25.0,
    duration: 30,
    isStartingPrice: true,
    popular: true,
    description: {
      nl: "Professioneel in model geföhnd met prachtig volume, gladheid en glans. (Vanaf prijs)",
      en: "Salon-finish blow-dry for luxurious bounce, smooth silkiness, or waves. (Starting price)",
      tr: "Düz, kırık veya dalgalı hacimli profesyonel fön çekimi. (Başlangıç fiyatı)"
    }
  },
  {
    id: "style-curling-iron",
    gender: "women",
    name: { nl: "Krullen met krultang / Wafels", en: "Curling iron curls & waves", tr: "Maşa ile bukle" },
    category: "hair_styling",
    categoryName: { nl: "Föhnen & Styling", en: "Blow-dry & Styling", tr: "Fön & Şekillendirme" },
    price: 49.5,
    duration: 45,
    isStartingPrice: true,
    description: {
      nl: "Schitterende Hollywood krullen of natuurlijke beach waves met professionele stylingtools. (Vanaf prijs)",
      en: "Glamorous Hollywood waves or soft beachy curls created with precision hot tools. (Starting price)",
      tr: "Özel maşa teknikleriyle kalıcı su dalgası, Hollywood bukleleri veya plaj dalgası. (Başlangıç fiyatı)"
    }
  },
  {
    id: "style-straightening",
    gender: "women",
    name: { nl: "Haar stijlen / Stijltang", en: "Hair flat iron straightening", tr: "Saç düzleştirme" },
    category: "hair_styling",
    categoryName: { nl: "Föhnen & Styling", en: "Blow-dry & Styling", tr: "Fön & Şekillendirme" },
    price: 35.0,
    duration: 40,
    isStartingPrice: true,
    description: {
      nl: "Zijdezacht steil haar met hittebeschermende premium serums. (Vanaf prijs)",
      en: "Silky flat iron straightening with heat protection serum for glossy finish. (Starting price)",
      tr: "Isı koruyucu serum eşliğinde ipeksi pürüzsüz düzleştirme. (Başlangıç fiyatı)"
    }
  },

  // 🌀 Perma (Kadın)
  {
    id: "w-perm",
    gender: "women",
    name: { nl: "Permanent behandeling", en: "Perm treatment", tr: "Perma işlemi" },
    category: "women_perm",
    categoryName: { nl: "Permanent", en: "Perm", tr: "Perma" },
    price: 110.0,
    duration: 90,
    isStartingPrice: true,
    popular: true,
    description: {
      nl: "Professionele permanentbehandeling voor veerkrachtige krullen, natuurlijke slag en langdurig volume. (Vanaf prijs)",
      en: "Professional perm treatment creating bouncy curls, natural waves, and long-lasting volume. (Starting price)",
      tr: "Saça hacim, dolgunluk ve uzun süre kalıcı doğal bukleler kazandıran profesyonel perma uygulaması. (Başlangıç fiyatı)"
    }
  },

  // 🌸 Kaş, Yüz ve Ağda (Kadın)
  {
    id: "wax-full-face",
    gender: "women",
    name: { nl: "Volledig gezicht harsen / waxen", en: "Full face waxing", tr: "Tüm yüz ağda" },
    category: "brows_face_wax",
    categoryName: { nl: "Wenkbrauwen, Gezicht & Wax", en: "Brows, Face & Waxing", tr: "Kaş, Yüz ve Ağda" },
    price: 35.0,
    duration: 30,
    popular: true,
    description: {
      nl: "Volledige gezichtsontharing met milde verzorgende wax voor een zijdezachte huid.",
      en: "Gentle full-face hair removal with soothing wax for baby-smooth skin.",
      tr: "Tüm yüzdeki ayva tüylerini ve istenmeyen tüyleri temizleyen hassas cilt ağdası."
    }
  },
  {
    id: "wax-thread-eyebrows",
    gender: "women",
    name: { nl: "Wenkbrauwen epileren met touw", en: "Eyebrow threading", tr: "İple kaş alma" },
    category: "brows_face_wax",
    categoryName: { nl: "Wenkbrauwen, Gezicht & Wax", en: "Brows, Face & Waxing", tr: "Kaş, Yüz ve Ağda" },
    price: 13.0,
    duration: 15,
    popular: true,
    description: {
      nl: "Traditionele draadtechniek voor perfect strakke en symmetrische wenkbrauwen.",
      en: "Traditional precision threading technique for clean, sharp, symmetrical eyebrows.",
      tr: "Geleneksel iple hassas ve simetrik kaş alımı ve şekillendirme."
    }
  },
  {
    id: "wax-eyebrows-wax",
    gender: "women",
    name: { nl: "Wenkbrauwen harsen / waxen", en: "Eyebrow waxing", tr: "Ağdayla kaş alma" },
    category: "brows_face_wax",
    categoryName: { nl: "Wenkbrauwen, Gezicht & Wax", en: "Brows, Face & Waxing", tr: "Kaş, Yüz ve Ağda" },
    price: 18.0,
    duration: 15,
    description: {
      nl: "Snelle en comfortabele wenkbrauwstyling met gevoelige huid wax.",
      en: "Quick and gentle waxing to shape and contour your eyebrows cleanly.",
      tr: "Özel organik yüz ağdası ile acısız ve hızlı kaş dizaynı."
    }
  },
  {
    id: "wax-brows-mustache",
    gender: "women",
    name: { nl: "Wenkbrauwen & bovenlip", en: "Eyebrows & upper lip waxing/threading", tr: "Kaş ve bıyık" },
    category: "brows_face_wax",
    categoryName: { nl: "Wenkbrauwen, Gezicht & Wax", en: "Brows, Face & Waxing", tr: "Kaş, Yüz ve Ağda" },
    price: 18.0,
    duration: 20,
    description: {
      nl: "Combinatiebehandeling van wenkbrauwen stylen en bovenlip ontharen met wax of draad.",
      en: "Complete grooming combo: eyebrow shaping and upper lip hair removal.",
      tr: "Kaş dizaynı ile birlikte bıyık/dudak üstü temizliği paketi."
    }
  },

  // =========================================================
  // 👨 2. ERKEK HİZMETLERİ (MEN'S SERVICES)
  // =========================================================

  // 💈 Erkek Saç ve Sakal
  {
    id: "m-haircut",
    gender: "men",
    name: { nl: "Heren knippen", en: "Men's haircut", tr: "Erkek saç kesimi" },
    category: "men_hair_beard",
    categoryName: { nl: "Heren Haar & Baard", en: "Men's Hair & Beard", tr: "Erkek Saç ve Sakal" },
    price: 25.0,
    duration: 30,
    popular: true,
    description: {
      nl: "Stijlvolle klassieke of moderne herenknipbeurt met schaar en tondeuse, inclusief styling wax.",
      en: "Classic or modern men's cut with scissors and clippers, finished with premium pomade.",
      tr: "Klasik veya modern makas ve makine saç kesimi, wax ile şekillendirme."
    }
  },
  {
    id: "m-wash-haircut",
    gender: "men",
    name: { nl: "Wassen en heren knippen", en: "Wash and men's haircut", tr: "Yıkama ve saç kesimi" },
    category: "men_hair_beard",
    categoryName: { nl: "Heren Haar & Baard", en: "Men's Hair & Beard", tr: "Erkek Saç ve Sakal" },
    price: 27.0,
    duration: 35,
    popular: true,
    description: {
      nl: "Verfrissende shampoo wasbeurt, hoofdhuidmassage en complete knipbeurt op maat.",
      en: "Refreshing hair wash, scalp massage, and precision haircut tailored to your head shape.",
      tr: "Ferahlatıcı şampuanla yıkama, kafa masajı ve özenli saç kesimi."
    }
  },
  {
    id: "m-hair-beard-combo",
    gender: "men",
    name: { nl: "Haar en baard knippen", en: "Haircut and beard trim", tr: "Saç ve sakal kesimi" },
    category: "men_hair_beard",
    categoryName: { nl: "Heren Haar & Baard", en: "Men's Hair & Beard", tr: "Erkek Saç ve Sakal" },
    price: 35.0,
    duration: 45,
    popular: true,
    description: {
      nl: "Complete herenknipbeurt gecombineerd met strakke baardcontouring met open mes en baardolie.",
      en: "Full haircut paired with straight-razor beard sculpt, neck cleanup, and nourishing oil.",
      tr: "Komple saç kesimi, ustura ile sakal hatları belirleme ve sakal bakım yağı."
    }
  },
  {
    id: "m-beard-shave-only",
    gender: "men",
    name: { nl: "Alleen baard scheren / trimmen", en: "Beard trim / shave only", tr: "Yalnızca sakal tıraşı" },
    category: "men_hair_beard",
    categoryName: { nl: "Heren Haar & Baard", en: "Men's Hair & Beard", tr: "Erkek Saç ve Sakal" },
    price: 17.5,
    duration: 20,
    description: {
      nl: "Scheren of trimmen van de baard, warme handdoek en strakke contouren.",
      en: "Beard trimming or shaving, warm towel compress, and razor line detailing.",
      tr: "Sakal şekillendirme, sıcak havlu kompresi ve sinekkaydı / hat tıraşı."
    }
  },
  {
    id: "m-boys-under-6",
    gender: "men",
    name: { nl: "Jongens knippen (tot 6 jaar)", en: "Boys haircut (under 6 yrs)", tr: "6 yaşına kadar erkek çocuk kesimi" },
    category: "men_hair_beard",
    categoryName: { nl: "Heren Haar & Baard", en: "Men's Hair & Beard", tr: "Erkek Saç ve Sakal" },
    price: 20.0,
    duration: 25,
    description: {
      nl: "Snelle, vriendelijke en stoere kindersnit voor jongens tot 6 jaar.",
      en: "Friendly, gentle and cool haircut for young boys up to 6 years.",
      tr: "Minik beylere özel neşeli, hızlı ve tarz saç kesimi."
    }
  },
  {
    id: "m-perm",
    gender: "men",
    name: { nl: "Heren permanent", en: "Men's perm", tr: "Erkek perma" },
    category: "men_hair_beard",
    categoryName: { nl: "Heren Haar & Baard", en: "Men's Hair & Beard", tr: "Erkek Saç ve Sakal" },
    price: 110.0,
    duration: 60,
    popular: true,
    description: {
      nl: "Klassieke of moderne permanentbehandeling voor heren voor natuurlijke krullen, textuur en volume.",
      en: "Classic or modern perm treatment for men, creating natural curls, definition, and volume.",
      tr: "Erkekler için saça modern dalga, doğal bukle ve hacim kazandıran profesyonel perma uygulaması."
    }
  },

  // 👂 Erkek Bakım & Ağda
  {
    id: "wax-ear-men",
    gender: "men",
    name: { nl: "Oor waxen heren", en: "Men's ear waxing", tr: "Erkekler için kulak ağdası" },
    category: "men_care_wax",
    categoryName: { nl: "Heren Verzorging & Wax", en: "Men's Grooming & Wax", tr: "Erkek Bakım & Ağda" },
    price: 10.0,
    duration: 10,
    description: {
      nl: "Snelle, hygiënische en doeltreffende oorwax voor heren.",
      en: "Hygienic and fast wax application to remove unwanted ear hair for men.",
      tr: "Kulak içi ve çevresindeki tüyler için hijyenik ve pratik ağda uygulaması."
    }
  },

  // 👑 Erkek Peruk
  {
    id: "hp-consultation",
    gender: "men",
    name: { nl: "Adviesgesprek & opmeten haarwerk", en: "Measurement & consultation", tr: "Ölçüm veya ön görüşme" },
    category: "mens_hairpiece",
    categoryName: { nl: "Haarwerk Heren", en: "Men's Hair Systems", tr: "Erkek Peruk" },
    price: 0.0,
    duration: 30,
    popular: true,
    description: {
      nl: "100% gratis en vrijblijvende intake, mal opmeten en haarstructuuranalyse.",
      en: "100% free and confidential hair system consultation, scalp template and color matching.",
      tr: "Tamamen ücretsiz ve gizlilik içinde saç rengi, kafa kalıbı ve model analizi."
    }
  },
  {
    id: "hp-full-package",
    gender: "men",
    name: { nl: "Compleet heren haarwerk pakket", en: "Men's hair system package", tr: "Erkek peruk paketi" },
    category: "mens_hairpiece",
    categoryName: { nl: "Haarwerk Heren", en: "Men's Hair Systems", tr: "Erkek Peruk" },
    price: 500.0,
    duration: 120,
    popular: true,
    description: {
      nl: "100% echt haarwerk, inclusief maatwerk plaatsing, medische verlijming en naadloos knippen.",
      en: "100% natural human hairpiece, custom skin-base fitting, medical adhesive bonding and cut.",
      tr: "%100 gerçek doğal saç protezi, kişiye özel kalıp, medikal sabitleme ve sıfır geçişli kesim."
    }
  },
  {
    id: "hp-monthly-maintenance",
    gender: "men",
    name: { nl: "Maandelijks onderhoud & styling haarwerk", en: "Monthly maintenance, styling & haircut", tr: "Aylık bakım, şekillendirme ve saç kesimi" },
    category: "mens_hairpiece",
    categoryName: { nl: "Haarwerk Heren", en: "Men's Hair Systems", tr: "Erkek Peruk" },
    price: 60.0,
    duration: 60,
    popular: true,
    description: {
      nl: "Losmaken, dieptereiniging, hoofdhuidverzorging, eigen haar knippen, nieuwe tapes en herplaatsing.",
      en: "Removal, deep detox, scalp refresh, side haircut, medical re-taping, refitting and styling.",
      tr: "Peruk sökümü, kafa derisi detoksu, yeni medikal bantlama, kendi saçınızı kesme ve şekillendirme."
    }
  }
];


